/** Общие опции React Query для справочников AI в редакторе (редко меняются). */
export const editorAiCatalogQueryOptions = {
  staleTime: 10 * 60 * 1000,
  refetchOnWindowFocus: false,
} as const;

/** Тяжёлые query редактора — не рефетчить при возврате во вкладку. */
export const editorHeavyQueryOptions = {
  refetchOnWindowFocus: false,
} as const;
